/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MDHospitalizationTypesController', MDHospitalizationTypesController);

    MDHospitalizationTypesController.$inject = ['KendoGrid', '$http', '$filter', 'KendoFilter', 'KendoService', 'HospitalizationType'];

    function MDHospitalizationTypesController (KendoGrid, $http, $filter, KendoFilter, KendoService, HospitalizationType) {
        var vm = this;
        vm.dataSource = {};
        vm.dataSource.parentHospitalizationTypes = KendoService.initDefaultDataSource('/api/masterdata/hospitalization-type-parents');

        var onSaveSuccess = function () {
            KendoGrid.refresh(vm.mainGridOptions);
        };

        vm.pageHeading = $filter('translate')('masterData.hospitalizationTypes.title');

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }
                        $http.get('/api/hospitalization-types/search',
                            {params: o.data})
                            .success(function (response) {
                                o.success(response);
                            })
                            .error(function (response) {});
                    },
                    create: function(o) {
                        var data = o.data.models[0];
                        HospitalizationType.update(data, onSaveSuccess);
                    },
                    update: function(o) {
                        var data = o.data.models[0];
                        HospitalizationType.update(data, onSaveSuccess);
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content !== undefined) {
                            data.content.forEach(function(item){
                                if (!item.hospitalizationTypeParent) item.hospitalizationTypeParent = {};
                            });
                        }
                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            name: { validation: { required: true , validation: { required: true, min: 3}}},
                            hospitalizationTypeParent: {defaultValue:  { name: "" }},
                            'hospitalizationTypeParent.name': { validation: { required: true , validation: { required: true, min: 3}}},
                            updatedAt: { editable: false }
                        }
                    }
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                pageSize: 20
            }),
            toolbar: [{name :"create", text: "Προσθήκη Νέας εγγραφής"},
                { template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            sortable: true,
            pageable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    field: "name", title: "Όνομα",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    field: "hospitalizationTypeParent.name",
                    title: "Κύριος Τύπος Ασφάλισης",
                    editor: function(container, options) {
                        angular.element('<select id="hospitalizationTypeParent" data-bind="value:hospitalizationTypeParent.id"></select>')
                            .appendTo(container)
                            .kendoComboBox({
                                dataSource: vm.dataSource.parentHospitalizationTypes,
                                filter: "startswith",
                                valuePrimitive: true,
                                dataTextField: "name",
                                dataValueField: "id"
                            });
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {
                    command:[
                        {name:"edit", text: "Επεξεργασία"}
                    ],
                    text: "Επεξεργασία",
                    title: "&nbsp;"
                }
            ],
            edit: function() { KendoGrid.defaultEditPopup(this._editContainer); },
            editable: "popup"
        };

    }
})();
